package io.horion.cv.pages.job.company

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.components.forms.JobFormLayout1
import io.horion.cv.components.forms.JobFormLayout2
import io.horion.cv.components.forms.NavigationButtons
import io.horion.cv.components.forms.StepIndicator
import io.horion.cv.models.Job
import io.horion.cv.models.JobStatus
import io.horion.cv.models.SalaryRange
import io.horion.cv.styles.CreateButtonStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import kotlinx.browser.window
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh


@OptIn(DelicateApi::class)
@Page("/job/create")
@Composable
fun Create(){

    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    val ctx = rememberPageContext()
    val breakpoint = rememberBreakpoint()
    var currentStep by remember { mutableStateOf(1) }
    //var colorMode by ColorMode.currentState
    var job by remember { mutableStateOf(Job()) }

 /*   val jobViewModel = koinGet< JobViewModel>()
    val job = jobViewModel.jobUiState*/
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .minHeight(100.vh)
            .backgroundColor(if (!isDark) Colors.LightGray else Colors.LightDark    ),
        verticalArrangement = Arrangement.Top,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Header(
            breakpoint, job = job,
            isDark = isDark
        )

        Column(
            modifier = Modifier.fillMaxWidth(),
            verticalArrangement = Arrangement.Top,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            StepIndicator(
                currentStep = currentStep,
                totalSteps = 2
            )

            // FORM CONTENT
            Box(
                modifier = Modifier.fillMaxWidth()
                    .maxWidth(1500.px)
//                    .height(750.px)
                    .weight(1f)
                    .padding( leftRight = 20.px)
                    .margin(bottom = 20.px)
                    .backgroundColor(if (isDark) Colors.holder else Colors.White)
                ,
            ) {
                when (currentStep) {
                    1 -> JobFormLayout1(
                        state = job,  // Passer l'état mutable
                        onStateChange = { job = it })

                    2 -> JobFormLayout2(
                        state = job,  // Passer l'état mutable
                        onStateChange = { job = it })
                }
            }
            // BOUTONS (collés en bas du bloc avec espace naturel)
            NavigationButtons(
                currentStep = currentStep,
                onNext = {
                    currentStep++
                },
                onPrevious = { currentStep-- },
                onCreate = {
                    val job = createJobFromStates(Job())
                    //onJobCreated(job)
                },
                onCancel = { ctx.router.navigateTo("/job") }
            )
        }
    }
}


@Composable
fun Header(
    breakpoint: Breakpoint,
    job: Job?,
    isDark: Boolean
) {
    //var showMenu by remember { mutableStateOf(false) }
    val iconFilter = if (isDark) "invert(1)" else "none"
    val ctx = rememberPageContext()
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .position(Position.Sticky) //pour rester sur place meme si on scrolle
            .top(0.px)
            .zIndex(10)
            .backgroundColor(if (isDark) Colors.holder else Colors.White)
            .padding(topBottom = 12.px)
            .borderBottom(1.px, LineStyle.Solid, Colors.LightGray)
    ) {

        Row(
            modifier = Modifier
                .fillMaxWidth(90.percent)
                .margin(leftRight = 30.px),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            Link(
                path = "/job",
                modifier = Modifier.textDecorationLine(TextDecorationLine.None)
            ) {
                Row(
                    modifier = Modifier
                        .cursor(Cursor.Pointer)
                        .margin(left = if (breakpoint > Breakpoint.MD) 95.px else 50.px),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    Image(
                        src = "/arrow-circle-left-black.svg",
                        modifier = Modifier.size(24.px)
                            .styleModifier { property("filter", iconFilter) }
                    )
                    SpanText(
                        text = "Retour",
                        modifier = Modifier
                            .margin(left = 10.px)
                            .fontSize(16.px)
                            .color(if(isDark) Colors.White else Colors.Black)
                    )
                }
            }
            Spacer()


            if (breakpoint > Breakpoint.MD) {
                Row(
                    modifier = Modifier
                        .margin(right = 520.px),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    SpanText(
                        text = job?.enterprise ?: "Compagnie",
                        modifier = Modifier
                            .margin(right = 10.px)
                            .fontFamily(INTER)
                            .fontSize(16.px)
                            .fontWeight(FontWeight.Bold)
                            .color(if (isDark) Colors.White else Colors.Black)
                    )
                    Image(
                        src = "/company.png",
                        modifier = Modifier.size(24.px)
                            .styleModifier { property("filter", iconFilter) }
                    )
                }
            }


            Row(
                verticalAlignment = Alignment.CenterVertically,
//            horizontalArrangement = Arrangement.End,
            ) {

                Button(
                    onClick = { ctx.router.navigateTo("/job/recruteur") },
                    modifier = CreateButtonStyle.toModifier()
                        .width(if (breakpoint <= Breakpoint.MD) 100.px else 150.px)
                        .height(if (breakpoint <= Breakpoint.MD) 36.px else 46.px)
                        .fontFamily(INTER)
                        .fontSize(if (breakpoint <= Breakpoint.MD) 11.px else 16.px)
                        .fontWeight(FontWeight.SemiBold)
                        .borderRadius(7.px)
                        .border(2.px, LineStyle.Solid, Colors.White)
                        .color(Colors.White)
                ) {
                    SpanText(
                        text = if (breakpoint <= Breakpoint.MD) "Gerer" else "Gerer mes postes",
                        modifier = Modifier.padding(leftRight = 8.px, topBottom = 4.px)
                    )
                }
            }
        }
    }
}

    fun createJobFromStates(job: Job): Job {
        return Job(
            enterprise = job.enterprise,
            title = job.title,
            city = job.city,
            type = job.type,
            description = job.description,
            requirements = job.requirements,
            responsibilities = job.responsibilities,
            salaryRange = SalaryRange(
                min = job.salaryRange.min,
                max = job.salaryRange.max
            ),
            // id = UUID.randomUUID().toString(),
            experience = job.experience,
            publicateAt = job.publicateAt,
            expire = job.expire,
            contactEmail = job.contactEmail,
            tags = job.tags,
            isRemote = job.isRemote,
            status = JobStatus.ACTIVE,
            createdAt = job.createdAt,
            updatedAt = job.updatedAt
        )
    }
